import React from 'react';

const reviews = [
  {
    id: 1,
    name: "Arjun Sharma",
    device: "iPhone 15 Pro",
    text: "Excellent service! My phone was fixed in 2 hours. They used original parts and the screen looks perfect.",
    img: "https://i.pravatar.cc/150?u=11"
  },
  {
    id: 2,
    name: "Rahul Verma",
    device: "Vivo X80 Pro",
    text: "Very professional and affordable pricing. The free doorstep pickup saved me so much time!",
    img: "https://i.pravatar.cc/150?u=22"
  },
  {
    id: 3,
    name: "Aman Kapoor",
    device: "Samsung S23 Ultra",
    text: "I thought my data was gone forever after water damage. These guys are magicians. 10/10!",
    img: "https://i.pravatar.cc/150?u=33"
  }
];

const ReviewH = () => {
  return (
    <section className="h-review-section">
      <div className="h-review-container">
        <div className="h-review-header">
          <div className="status-indicator">
            <span className="pulse-dot"></span>
            1,200+ Happy Clients
          </div>
          <h2> <span className="blue-gradient">Customer Experience</span></h2>
        </div>

        <div className="h-review-grid">
          {reviews.map((rev) => (
            <div className="h-card" key={rev.id}>
              <div className="h-card-top">
                <div className="h-stars">⭐⭐⭐⭐⭐</div>
                <div className="h-device-tag">{rev.device}</div>
              </div>
              
              <p className="h-text">"{rev.text}"</p>
              
              <div className="h-user">
                <div className="h-avatar-wrap">
                  <img src={rev.img} alt={rev.name} />
                  <div className="h-check-badge">✓</div>
                </div>
                <div className="h-user-info">
                  <h4>{rev.name}</h4>
                  <p>Verified Repair</p>
                </div>
              </div>
              
              {/* Background decorative element */}
              <div className="h-card-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewH;